export const LANGUAGE_PR = 'es';
export const LANGUAGE_USA = 'en-US';
